/*
	a collection of global string manipulation functions
*/
import Vue from 'vue';


let sec = 1000,
	min = 1000*60,
	hour = 1000*60*60,
	day = 1000*60*60*24,
	week = 1000*60*60*24*7,
	month = 1000*60*60*24*30,
	year = 1000*60*60*24*365, 
	months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	monthsShort = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
	weekdays = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
	weekdaysShort = ['sun','mon','tues','wed','thu','fri','sat'];

let longDate = function(dateStr){
	if (dateStr === null || dateStr === '0001-01-01T00:00:00Z') return '-';
	let d = new Date(dateStr);

	let day = d.getDate();
	let monthIndex = d.getMonth();
	let year = d.getFullYear();

	return months[monthIndex] + ' ' + day + ', ' + year;
};

// commas will take in a number and return a string with commas as the thousand marks
// https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
Vue.filter('numberWithCommas', function(val){
	return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

//	will format a 10 digit string into 123-456-78-90
Vue.filter('apn', function (val) {
	if (!val || val.length != 10){
		return val;
	}

	//	123-456-78-90
	return val.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "$1-$2-$3-$4");
});

//	format as dollars, no cents with commas. we set this up so it's cached for subsequent calls
let currencyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 0
});

Vue.filter('currency', function(val){
	return currencyFormatter.format(val);
});

Vue.filter('time', function(dateStr){
	let d = new Date(dateStr);

	let hours = d.getHours();
	let minutes = d.getMinutes();
	const ampm = hours >= 12 ? 'PM' : 'AM';
	hours = hours % 12;
	hours = hours ? hours : 12; // the hour '0' should be '12'
	minutes = minutes < 10 ? '0'+minutes : minutes;
	return hours + ':' + minutes + ' ' + ampm;
});

Vue.filter('longDate', function(dateStr){
	return longDate(dateStr);
});

Vue.filter('yearShort', function(year){
	return String(year).substr(2);
});

Vue.filter('ago', function(dateStr){
	let d = new Date(dateStr);

	let nowDate = new Date();
	let nowTs = nowDate.getTime();
	let diff = nowTs - d.getTime();
	if (diff < 2*sec) return '1 sec ago';
	if (diff < min) return Math.round(diff/sec)+' secs ago';
	if (diff < hour) return Math.round(diff/min)+' min ago';
	if (diff < 2*hour) return '1 hr ago';
	if (diff < day) return Math.round(diff/hour)+' hrs ago';
	if (diff < 2*day) return 'yesterday';
	if (diff < week) return Math.round(diff/day)+' days ago';
	if (diff < 2*week) return 'a week ago';
	if (diff < month) return Math.round(diff/week)+' weeks ago';
	if (diff < 2*month) return 'a month ago';

	return longDate(dateStr);


	if (diff < year) return Math.round(diff/month)+' months ago';
	if (diff < 2*year) return 'a year ago';
	return done.pass(Math.round(diff/year)+' years ago');

});

Vue.filter('integerLg', function(num){
	return Number(num).toLocaleString();
});


// WEBPACK FOOTER //
// ./src/filters/formatter.js